import React from 'react';
import { ISimilarReport } from '../../models';
import Modal from '../Modal';
import i18next from 'i18next';
import ModalImage from '../ModalImage';
import { useTranslation } from 'react-i18next';
import { MdCheck, MdClose } from 'react-icons/md';

export default function SimilarReport(props: {
    onClose: () => void;
    report: ISimilarReport | null;
}) {
    console.log(props.report);
    const { t } = useTranslation();
    return (
        <Modal
            show={!!props.report}
            onClose={props.onClose}
            width={700}
            notChangeOverflow={true}
            showClose={true}>
            {props.report && (
                <div className={'mx-10 my-10'}>
                    <h1 className={'mb-3 text-center font-medium'}>
                        {t('translation:REPORT.SIMILAR_REPORT.SIMILAR_REPORT_FOUND')}
                    </h1>
                    <div className={'rounded border-2 border-SM-yellow p-5'}>
                        <img
                            alt={'report position'}
                            className={`mb-3 w-full object-cover`}
                            src={`https://maps.googleapis.com/maps/api/staticmap?markers=color:0xF7AA45|${props.report.report.localization.lat},${props.report.report.localization.lon}&size=600x300&scale=2&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&language=${i18next.language}&style=feature:poi|visibility:off`}
                        />

                        <div className={'mr-auto'}>
                            <p className={'my-0.5 text-sm'}>
                                <b>{t('translation:REPORT.SIMILAR_REPORT.TITLE')}:</b>{' '}
                                {props.report.report.title}
                            </p>
                            <p className={'my-0.5 text-sm'}>
                                <b>{t('translation:REPORT.SIMILAR_REPORT.CATEGORY')}:</b>{' '}
                                {t(`translation:REPORT_TYPE.${props.report.report.category}`)}
                            </p>
                            <p className={'my-0.5 text-sm'}>
                                <b>{t('translation:REPORT.SIMILAR_REPORT.DESCRIPTION')}:</b>{' '}
                                {props.report.report.description}
                            </p>
                            <p className={'my-0.5 text-sm'}>
                                <b>{t('translation:REPORT.SIMILAR_REPORT.REPORT_DATE')}:</b>{' '}
                                {new Date(props.report.report.createdAt).toLocaleDateString(
                                    i18next.language,
                                    {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                    },
                                )}
                            </p>
                        </div>

                        <div className={'flex gap-2'}>
                            {props.report.report.attachments.map((attachmentID) => {
                                return (
                                    <div
                                        key={`image-${attachmentID}`}
                                        className={'mt-2 rounded border p-1'}>
                                        <ModalImage
                                            notChangeOverflow={true}
                                            className={'w-[120px]'}
                                            image={
                                                process.env.REACT_APP_CDN_URL +
                                                '/files/' +
                                                attachmentID
                                            }
                                            alt={'report attachment'}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className={'mt-2 flex flex-col items-center rounded bg-slate-100 p-4'}>
                        <h4 className={'mb-1 font-medium'}>
                            {t('translation:REPORT.SIMILAR_REPORT.WAS_THAT_WHAT_YOU_MEANT')}
                        </h4>
                        <div className={'flex gap-4'}>
                            TODO: Add bump report mechanism
                            <button
                                className={'btn-filled bg-green-600 text-white ring-green-600/50'}>
                                <MdCheck className={'text-lg'} />
                                {t('translation:REPORT.SIMILAR_REPORT.YES')}
                            </button>
                            <button className={'btn-filled bg-red-600 text-white ring-red-600/50'}>
                                <MdClose className={'text-lg'} />
                                {t('translation:REPORT.SIMILAR_REPORT.NO')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Modal>
    );
}
